/* Model */
class HoursOfServiceTypeDaysModel extends App.Models.BaseModel {
    modelUrl = 'HoursOfServiceTypeDays';

    fetchWithCriteria = (obj) => {
        return Monet.Model.fetchWithCriteria({
            options: obj,
            model: this
        });
    }
}

App.Models.HoursOfServiceTypeDays = HoursOfServiceTypeDaysModel;

/* Collection */
class HoursOfServiceTypeDaysCollection extends App.Collections.BaseCollection {
    url = 'HoursOfServiceTypeDays';
    model = App.Models.HoursOfServiceTypeDays;
}

App.Collections.HoursOfServiceTypeDayss = HoursOfServiceTypeDaysCollection;

/* Router */
class HoursOfServiceTypeDaysRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'HoursOfServiceTypeDays';
        const model = App.Models.HoursOfServiceTypeDays;
        const collectionClass = App.Collections.HoursOfServiceTypeDayss;

        super(entityName, model, collectionClass);
    }

    setParentId = (parentId) => {
        this.parentId = parentId;
    }

    afterCreateForm = () => {
        const btnCancel = $("#HoursOfServiceTypeDays [name='btn_cancel']");
        btnCancel.off();
        btnCancel.on("click", () => {
            window.location = "#/HoursOfServiceType/" + this.parentId + "/HoursOfServiceTypeDays";
        });

        this.setHosTypeId(this.parentId);
    };

    setHosTypeId = (hosTypeId) => {
        this.parentId = hosTypeId || this.parentId;
        App.Forms.HoursOfServiceTypeDays.hosTypeId = this.parentId;

        const field = App.Forms.HoursOfServiceTypeDays.form.fields['hoursOfServiceType.id'];
        if (field) {
            field.setValue(this.parentId);
        }
    };

    beforeCreate = (model_to_create) => {
        const id = model_to_create.attributes['hoursOfServiceType.id'];
        delete model_to_create.attributes['hoursOfServiceType.id'];
        model_to_create.attributes.hoursOfServiceType = { "id": id };
    };

    beforeUpdate = (updateModel) => {
        let id = null;
        if (updateModel.attributes) {
            id = updateModel.attributes['hoursOfServiceType.id'];
            delete updateModel.attributes['hoursOfServiceType.id'];
            updateModel.attributes.hoursOfServiceType = { "id": id };
        } else {
            id = updateModel['hoursOfServiceType.id'];
            delete updateModel['hoursOfServiceType.id'];
            updateModel.hoursOfServiceType = { "id": id };
        }
    }

    afterCreate = (model) => {
        const id = model.attributes.hoursOfServiceType.id;
        window.location = "#/HoursOfServiceType/" + id + "/HoursOfServiceTypeDays";
    }

    afterDestroy = (model) => {
        const id = model.attributes.hoursOfServiceType.id;
        window.location = "#/HoursOfServiceType/" + id + "/HoursOfServiceTypeDays";
    }

    beforeList = () => {
        this.addListeners();
        this.collectionFilter = '{"hoursOfServiceType" : {"id" : ' + this.parentId + '}}';
        const filterBuilder = App.Forms.HoursOfServiceTypeDays.filterBuilder;

        filterBuilder.callbackBeforeFilter = () => {
            filterBuilder.criteriaChain.criteriaChain[0].and.push({
                attr: 'hoursOfServiceType.id',
                eq: this.parentId
            });
        };
    }

    addListeners = () => {
        const btnNew = $("#HoursOfServiceTypeDays [name='btn_new']");
        btnNew.off();
        btnNew.on("click", () => {
            window.location = "#/HoursOfServiceType/" + this.parentId + "/HoursOfServiceTypeDays/new";
        });
    }
}

App.Routers.HoursOfServiceTypeDays = HoursOfServiceTypeDaysRouter;
